// File: src/utils/formatting.js

export function formatCurrency(value) {
  if (typeof value !== 'number') return '£0.00';
  return `£${value.toFixed(2)}`;
}

export function formatDateTime(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleString();
}
